import api from './api';

const invoiceService = {
    createInvoice: async (data) => {
        const response = await api.post('/invoices', data);
        return response.data;
    },

    previewInvoice: async (data) => {
        const response = await api.post('/invoices/preview', data, {
            responseType: 'blob'
        });
        return response.data;
    },

    getAllInvoices: async (transporteurId) => {
        const response = await api.get(`/invoices/transporteur/${transporteurId}`);
        return response.data;
    },

    getInvoice: async (id) => {
        const response = await api.get(`/invoices/${id}`);
        return response.data;
    },

    downloadPdf: async (id) => {
        const response = await api.get(`/invoices/${id}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    },

    updateStatus: async (id, status) => {
        const response = await api.patch(`/invoices/${id}/status`, null, {
            params: { status }
        });
        return response.data;
    },

    submitToPdp: async (id) => {
        const response = await api.post(`/invoices/${id}/submit-pdp`);
        return response.data;
    },

    refreshPdpStatus: async (id) => {
        const response = await api.post(`/invoices/${id}/refresh-pdp-status`);
        return response.data;
    },

    getNextInvoiceNumber: async () => {
        const response = await api.get('/invoices/next-number');
        return response.data;
    },

    createCreditNote: async (id, missionIds) => {
        const response = await api.post(`/invoices/${id}/credit-note`, missionIds);
        return response.data;
    },
};

export default invoiceService;
